import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { FeedbackSurvey, type SurveyContext } from "@/components/feedback/FeedbackSurvey";
export async function feedbackPublicRequest(body: object) {
  const response = await fetch("/api/feedback/public", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Impossible d’enregistrer votre avis.");
  return data;
}
export default function PublicFeedbackPage() {
  const { token } = useParams();
  const [query] = useSearchParams();
  const [context, setContext] = useState<SurveyContext | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let cancel = false;
    setContext(null);
    void feedbackPublicRequest({ action: "context", token }).then(
      (data) => {
        if (!cancel) setContext(data);
      },
      (e) => {
        if (!cancel) setError(e.message);
      },
    );
    return () => {
      cancel = true;
    };
  }, [token]);
  const score = query.get("score");
  const initialScore = score && /^[1-5]$/.test(score) ? Number(score) : null;
  if (!context)
    return (
      <div className="min-h-screen bg-[#EFEEF3] p-10 text-center">
        <h1 className="mb-4 text-xl font-semibold">Smile World</h1>
        <p role={error ? "alert" : "status"}>{error || "Chargement de votre formulaire…"}</p>
      </div>
    );
  return (
    <FeedbackSurvey
      key={token}
      context={context}
      initialScore={initialScore}
      onExpress={async (answers) => {
        await feedbackPublicRequest({ action: "express", token, answers });
      }}
      onDetails={async (answers) => {
        await feedbackPublicRequest({ action: "details", token, answers });
      }}
    />
  );
}
